
import React from 'react';
import HeroSection from '@/components/launchpad/HeroSection';
import ProblemSolutionSection from '@/components/launchpad/ProblemSolutionSection';
import CourseContentSection from '@/components/launchpad/CourseContentSection';
import LaunchpadFAQ from '@/components/launchpad/LaunchpadFAQ';
import FinalCTASection from '@/components/launchpad/FinalCTASection';
import CountdownTimer from '@/components/CountdownTimer';
const Launchpad = () => {
  // Set target date to June 12th, 2025 at 12:00 AM EST
  const launchSpecialTargetDate = new Date('2025-06-12T05:00:00.000Z'); // 12:00 AM EST = 5:00 AM UTC

  return <div className="min-h-screen flex flex-col bg-gradient-to-b from-[#003a70]/5 to-white">
      {/* Launch Special Countdown Banner */}
      

      <main className="flex-grow">
        <HeroSection />
        <ProblemSolutionSection />
        <CourseContentSection />
        <LaunchpadFAQ />
        <FinalCTASection />
      </main>
    </div>;
};
export default Launchpad;
